document.addEventListener('DOMContentLoaded', function () {
    // 用 button 后 Enter / Space 会走原生 click；这里同步展开态给读屏
    $('.faq-slider .question').click(function () {
        var $question = $(this);
        var $answer = $question.next('.answer');
        if ($answer.is(':hidden')) {
            $question.addClass('isopen').attr('aria-expanded', 'true');
        } else {
            $question.removeClass('isopen').attr('aria-expanded', 'false');
        }
        $answer.slideToggle();
    });
});